import { create } from 'zustand';

export interface Notification {
  id: string;
  title: string;
  description?: string;
  type?: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
}

interface NotificationStore {
  notifications: Notification[];
  addNotification: (notification: Omit<Notification, 'id'>) => void;
  removeNotification: (id: string) => void;
  clearNotifications: () => void;
}

export const useNotificationStore = create<NotificationStore>((set) => ({
  notifications: [],

  addNotification: (notification) => {
    const id = Date.now().toString();
    set((state) => ({
      notifications: [...state.notifications, { ...notification, id }],
    }));
  },

  removeNotification: (id) => {
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    }));
  },

  clearNotifications: () => {
    set({ notifications: [] });
  },
}));

// Helper functions for common notifications
export const notify = {
  success: (title: string, description?: string) => {
    useNotificationStore.getState().addNotification({
      title,
      description,
      type: 'success',
    });
  },

  error: (title: string, description?: string) => {
    useNotificationStore.getState().addNotification({
      title,
      description,
      type: 'error',
      duration: 8000, // Errors stay longer
    });
  },

  warning: (title: string, description?: string) => {
    useNotificationStore.getState().addNotification({
      title,
      description,
      type: 'warning',
    });
  },

  info: (title: string, description?: string) => {
    useNotificationStore.getState().addNotification({
      title,
      description,
      type: 'info',
    });
  },
};
